// src/hooks/productTypes/useDeleteProductTypes.js
import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { deleteProductType } from "../../api/apiProductTypes";
import parseError from "../../utils/parseError";

const useDeleteProductTypes = () => {
    const queryClient = useQueryClient();

    const { mutate: deleteProductTypes, isPending: isDelete } = useMutation({
        mutationFn: deleteProductType,
        onSuccess: (res) => {
            const message = res?.message || "Product type deleted successfully";
            toast.success(message);
            queryClient.invalidateQueries({ queryKey: ["productTypes"] });
        },
        onError: (error) => {
            const msg = parseError(error);
            toast.error(msg || "Failed to delete product type");
        },
    });

    return { deleteProductTypes, isDelete };
};

export default useDeleteProductTypes;